import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService } from '@azure/msal-angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';



import { ButtonModule } from 'primeng/button';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToolbarModule } from 'primeng/toolbar';
import { MenuModule } from 'primeng/menu';
import { IconModule, LinkV2Module } from '@gea/digital-ui-lib';
import { GeaLibraryModule } from './gea-library.module';
import { HeaderComponent } from './components/header/header.component';
import { DeleteValidatorComponent } from './components/delete-validator/delete-validator.component';
import { NoAccessComponent } from './components/no-access/no-access.component';


@NgModule({
  declarations: [HeaderComponent, DeleteValidatorComponent, NoAccessComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      }
    }),
    ButtonModule,
    ToolbarModule,
    MenuModule,
    HttpClientModule,
    LinkV2Module,
    GeaLibraryModule
  ],
  providers: [],
  exports: [HeaderComponent, TranslateModule, NoAccessComponent]
})
export class SharedModule { }
